// @flow

// Lots of different content will overlay the Pin visual. ContentLayer is a
// container with the proper layer styles. Note that individual layers can
// potentially overlap each other, so content that co-interacts (such as action
// bar and footer) must be placed in the same layer.

import React, { type Node } from 'react';
import { Box } from 'gestalt';

type Props = {|
  additionalStyles?: Object,
  children?: Node,
|};

export default function ContentLayer({ children, additionalStyles = {} }: Props) {
  return (
    <Box
      position="absolute"
      top
      left
      right
      bottom
      dangerouslySetInlineStyle={{ __style: { pointerEvents: 'none', ...additionalStyles } }}
    >
      {children}
    </Box>
  );
}
